import { useCallback } from 'react';
import showToast from '@/components/ui/Toast';

/**
 * Custom hook for consistent toast messaging across the application
 */
export const useToast = () => {
  // Success messages
  const showSuccess = useCallback((message: string) => {
    showToast.success(message);
  }, []);

  // Error messages with better error handling
  const showError = useCallback((error: any, defaultMessage = 'Terjadi kesalahan') => {
    let errorMessage = defaultMessage;

    if (error?.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error?.message) {
      errorMessage = error.message;
    } else if (typeof error === 'string') {
      errorMessage = error;
    }

    showToast.error(errorMessage);
  }, []);

  // Loading toast
  const showLoading = useCallback((message: string) => {
    return showToast.loading(message);
  }, []);

  // Promise-based toast for async operations
  const showPromise = useCallback(
    <T>(
      promise: Promise<T>,
      messages: {
        loading: string;
        success: string | ((data: T) => string);
        error: string | ((error: any) => string);
      }
    ) => {
      return showToast.promise(promise, messages);
    },
    []
  );

  // Dismiss functions
  const dismiss = useCallback((toastId?: string) => {
    showToast.dismiss(toastId);
  }, []);

  const dismissAll = useCallback(() => {
    showToast.dismissAll();
  }, []);

  return {
    success: showSuccess,
    error: showError,
    loading: showLoading,
    promise: showPromise,
    dismiss,
    dismissAll,
  };
};

export default useToast;
